import axios from 'axios';
import { getCookie } from '../utilities/cookies';


const APP_BACKENDS = {
  hr: 'https://hr.clikkle.com:8000',
  projects: 'https://projects.clikkle.com:8500',
  project: 'https://projects.clikkle.com:8500',
  chat: 'https://chat.clikkle.com:9100',
  campaigns: 'https://campaigns.clikkle.com:9000',
  worksuite: 'https://app.clikkle.com:9160',
  app: 'https://app.clikkle.com:9160',
};


export const isOrgBasedApp = (type) => {
  const orgBasedApps = ['hr', 'projects', 'project', 'chat', 'campaigns', 'worksuite', 'app'];
  return orgBasedApps.includes(type?.toLowerCase());
};

const parseSizeToNumber = (label) => {
  if (!label) return 1;
  const rangeMatch = label.match(/(\d+)\s*-\s*(\d+)/);
  if (rangeMatch) {
    // Use upper bound of the range
    return Number(rangeMatch[2]);
  }
  const aboveMatch = label.match(/(\d+)\s*and\s*above/i);
  if (aboveMatch) {
    return Number(aboveMatch[1]);
  }
  const singleMatch = label.match(/\d+/);
  return singleMatch ? Number(singleMatch[0]) : 1;
};

const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const provisionOrganization = async (type, userId, userData) => {
  const appType = type?.toLowerCase();
  const baseUrl = APP_BACKENDS[appType];
  const accessToken = getCookie('clikkleStoreAccessToken');
  const refreshToken = getCookie('refreshToken');

  if (!baseUrl) {
    throw new Error(`No backend URL defined for app type: ${type}`);
  }

  if (!accessToken || accessToken === "undefined") {
    console.error("No access token available for provisioning");
    throw new Error("Authentication required. Please log in again.");
  }

  const orgName = `${userData.firstName}'s Org`;
  let projUser = null;

  if (appType === 'projects' || appType === 'project' || appType === 'worksuite' || appType === 'app') {
    try {
      const loginPayload = {
        userName: userId.username || userId.userName || "",
        recoveryEmail: userId.recoveryEmail || userId.email || "",
        firstName: userId.firstName || userId.fullName?.split(' ')[0] || "",
        lastName: userId.lastName || userId.fullName?.split(' ').slice(1).join(' ') || ""
      };
      const loginResponse = await axios.post('https://projects.clikkle.com:8500/api/v2/auth/login', loginPayload);
      if (loginResponse.data && loginResponse.data.userDetails) {
        projUser = loginResponse.data.userDetails;
      }
    } catch (error) {
      console.error("Login to projects failed:", error.response?.data || error.message);
      throw new Error("Failed to authenticate with Projects service.");
    }
  }

  let logoBlob = null;
  try {
    const logoResponse = await fetch('/clikkle.png');
    if (logoResponse.ok) {
      logoBlob = await logoResponse.blob();
    }
  } catch (error) {
    console.error("Failed to fetch local logo:", error);
  }

  try {
    let response;

    if (appType === 'hr') {
      let formData = new FormData();
      formData.append("name", orgName + " " + Math.random().toString(36).substring(2, 4));
      formData.append("email", userData.email || "");
      formData.append("website", "https://worksuite.clikkle.com");
      formData.append('portalName', `hr.clikkle.com/${orgName.toLowerCase().replace(/[^a-z0-9]/g, '')}`);
      formData.append('plan', userData.planName);
      formData.append('industry', 'Other');
      formData.append('organizationSize', '0 - 15');
      if (logoBlob) {
        formData.append("photo", logoBlob, "clikkle.png");
      }

      response = await axios.post(`${baseUrl}/hr/organization`, formData, {
        headers: {
          "Authorization": `Bearer ${accessToken}`
        },
      });
    }
    else if (appType === 'chat') {
      let formData = new FormData();
      formData.append("name", orgName);
      formData.append("email", userData.email || "");
      formData.append("website", "https://worksuite.clikkle.com");
      formData.append("portalName", `chat.clikkle.com/${orgName.toLowerCase().replace(/[^a-z0-9]/g, '')}`);
      formData.append("plan", userData.planName);
      formData.append("industry", "Other");
      formData.append("organizationSize", "0 - 15");
      if (logoBlob) {
        formData.append("photo", logoBlob, "clikkle.png");
      }

      response = await axios.post(`${baseUrl}/api/organization`, formData, {
        headers: {
          "Authorization": `Bearer ${refreshToken}`
        },
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    }
    else if (appType === 'projects' || appType === 'project') {
      const formData = new FormData();

      // Projects backend expects imageUrl as a string (URL), not a file field.
      // Sending it as a Blob with a filename makes it a file field, which causes MulterError: Unexpected field.
      formData.append("imageUrl", 'https://cdn.clikkle.com/images/clikkle/logo/2025/clikkle.png');

      formData.append("ownerId", userId._id || userId);
      formData.append("userId", projUser?._id || userId._id || userId);
      formData.append("name", orgName);
      formData.append("email", userData.email || "");
      formData.append("website", "https://worksuite.clikkle.com");
      // Use the portalName format from the working ProjectsCreateOrg.js
      formData.append("portalName", `projects.clikkle.com/${orgName.toLowerCase().replace(/\s+/g, '')}`);
      formData.append("plan", userData.planName);
      formData.append("industry", "Other");
      formData.append("organizationSize", "0 - 15");
      formData.append("ownerEmail", userId.recoveryEmail || userData.email || "");

      console.log("Form Data Content:", [...formData.entries()]);

      response = await axios.post(`${baseUrl}/api/v2/organizations`, formData, {
        headers: {
          "Authorization": `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data"
        },
      });
    }
    else if (appType === 'campaigns' || appType === 'campaign') {
      const payload = {
        name: orgName,
        Email: userData.email || "",
        Website: "https://worksuite.clikkle.com",
        Address: "Not Provided",
        Country: "Not Provided",
        ZipCode: "00000",
        City: "Not Provided",
        CompanyIndustry: "Other",
        userId: userId._id || userId,
        ownerId: userId._id || userId,
        size: 1,
        logo: "https://cdn.clikkle.com/images/campaigns/logo/2025/clikkle%20campaigns.png"
      };

      console.log("Payload Content:", payload);

      response = await axios.post(`${baseUrl}/user/organizations`, payload, {
        headers: {
          "Authorization": `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        },
      });
      console.log("Campaigns provisioning response:", response);
    }
    else if (appType === 'worksuite' || appType === 'app') {
      const orgSizeNumber = parseSizeToNumber(userData.organizationSize || "0 - 15");
      const portalName = `app.clikkle.com/${orgName.toLowerCase().replace(/\s+/g, '')}`;

      let image = 'https://cdn.clikkle.com/images/clikkle/logo/2025/clikkle.png';
      if (logoBlob) {
        try {
          image = await blobToBase64(logoBlob);
        } catch (e) {
          console.error("Error converting logo blob to base64:", e);
        }
      }

      const organizationData = {
        // Common
        name: orgName,
        // Main database fields (use capitalized keys expected by schema)
        Email: userData.email || "",
        Size: orgSizeNumber,
        Website: "https://worksuite.clikkle.com",
        Address: "Not Provided",
        Country: "Not Provided",
        ZipCode: "00000",
        City: "Not Provided",
        CompanyIndustry: "Other",
        logo: image,
        createdAt: new Date().toISOString(),
        userId: userId._id || userId,
        ownerId: userId._id || userId,
        owner: userId._id || userId,

        // HR database fields
        email: userData.email || "",
        plan: userData.planName || "Starter Plan",
        portalName: portalName,
        organizationSize: userData.organizationSize || "0 - 15",
        industry: "Other",
        website: "https://worksuite.clikkle.com",
        status: true,
        folderId: userId._id || userId,

        // Projects database fields
        imageUrl: image,
        members: userId ? [userId._id || userId] : [],
        type: "Owner",
        totalEmployees: 1,
        projectUserId: projUser?._id
      };

      console.log("Payload Content:", organizationData);

      response = await axios.post(`${baseUrl}/api/organizations`, organizationData, {
        headers: {
          "Authorization": `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        },
      });
    }

    if (response && response.data) {
      const data = response.data;
      console.log(`Provisioning response for ${appType}:`, data);


      const orgId = data.orgId || data.organizationId || data._id ||
        data.organization?._id ||
        data.data?._id ||
        (data.success && data.organization?._id) ||
        data.data?.orgId || data.data.main?._id;
        
      if (orgId) {
        localStorage.setItem("orgId", orgId);
        return orgId;
      }
    }

    throw new Error("Invalid response from provisioning API");
  } catch (error) {
    console.error(`Provisioning failed for ${appType}:`, error.response?.data || error.message);
    throw error;
  }
};
